import {formatBirthdateToText, formatDateToText} from '../../../../../../helpers/modalBenhAn';
import CustomComponent from '../components/CustomComponent';
import {HO_SO_BENH_AN_FORM} from '../../../../../../constants/BenhAn';
import {useDetailHoSoBenhAn, useMedicalRecordFormIO} from '../../../../../../modals/modal-benh-an/hooks/hoSoBenhAn';
import {OctGenerateForm} from '@oceantech/oceantech-ui';
import {usePhanHeKhamBenhContext} from "../../../../../../contexts/PhanHeTiepDonContext";

const TrangBia = (props: any) => {
  const {benhNhanInfo} = usePhanHeKhamBenhContext();

  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

  const {formJSON} = useMedicalRecordFormIO({
    medicalRecordCode: props.medicalRecordTypeCode,
    formCode: HO_SO_BENH_AN_FORM.TRANG_BIA,
  });
  const {data} = useDetailHoSoBenhAn({
    medicalRecordId: benhNhanDieuTri?.encounterIdExec,
    formName: HO_SO_BENH_AN_FORM.TRANG_1,
  });


  return (
    <OctGenerateForm
      listFieldAuto={formJSON}
      values={{
        forms: data
      }}
      modelID="forms"
      readOnly
      customComponent={CustomComponent}
      fieldConditionalConfig={{
        formatBirthdateToText,
        formatDateToText,
      }}
    />
  );
};

export default TrangBia;
